
export class GrupoSocioDto {
	idSocio: number;
}
